'use strict';

var typeMap = {};

var bmp = require('./types/bmp').detect;
var gif = require('./types/gif').detect;
var jpg = require('./types/jpg').detect;
var png = require('./types/png').detect;
var tiff = require('./types/tiff').detect;

typeMap = {
  bmp,
  gif,
  jpg,
  png,
  tiff,
}

module.exports = function(buffer, filepath) {
  var type, result;
  for (type in typeMap) {
    if (type in typeMap) {
      result = typeMap[type](buffer, filepath);
      if (result) {
        return type;
      }
    }
  }
  throw new TypeError('Unsupported type');
};
